import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_NOTIFICATION_REQUEST,
  ADD_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION_FAILURE,
  UPDATE_NOTIFICATION_REQUEST,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAILURE,
} from "../constants/notificationConstant";

export const addNotificationAction = (notificationData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_NOTIFICATION_REQUEST });
    console.log(notificationData);

    const url = ApiUrl.createNotificationForAdmin;
    const { data } = await axios.post(url, notificationData);

    if (data.success) {
      dispatch({
        type: ADD_NOTIFICATION_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_NOTIFICATION_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_NOTIFICATION_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};

export const updateNotificationAction =
  (notificationId, notificationDetails) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_NOTIFICATION_REQUEST });
      const URL = `${ApiUrl.updateNotificationForAdmin}?notificationId=${notificationId}`;
      const { data } = await axios.put(URL, notificationDetails);
      if (data.success) {
        dispatch({
          type: UPDATE_NOTIFICATION_SUCCESS,
          payload: data,
        });
        return true;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_NOTIFICATION_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_NOTIFICATION_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const deleteNotificationAction =
  (notificationId) => async (dispatch) => {
    try {
      dispatch({ type: DELETE_NOTIFICATION_REQUEST });
      const URL = `${ApiUrl.deleteNotification}?notificationId=${notificationId}`;

      const { data } = await axios.delete(URL);
      console.log("response", data);
      if (data.success) {
        dispatch({
          type: DELETE_NOTIFICATION_SUCCESS,
          payload: data.success,
        });
        console.log("response", data);
        return true;
      }
      return false;
    } catch (error) {
      dispatch({
        type: DELETE_NOTIFICATION_FAILURE,
        payload: error.response.data,
      });
    }
  };

export const getNotification = (notificationId) => async (dispatch) => {
  try {
    dispatch({ type: GET_NOTIFICATION_REQUEST });
    const URL = `${ApiUrl.notificationById}?notificationId=${notificationId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_NOTIFICATION_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_NOTIFICATION_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_NOTIFICATION_FAILURE,
        payload: error.response.data,
      });
    }
  }
};
